// As métricas de sono que o app AINDA NÃO LÊ — a lista "futuro" do Insights.
//
// Por que ela vive aqui e não inline na página: a lista de Sleep.tsx prometia
// "quando disponível" para Heart Rate Variability — que JÁ é lida
// (heartRateVariability está em HEALTH_READ_TYPES) e aparece como tendência na
// MESMA tela. A tela se desmentia a dois cards de distância. Inline, nada
// impedia a próxima métrica promovida de repetir o erro: promover um tipo a
// HEALTH_READ_TYPES não tocava a lista de promessas.
//
// O contrato agora é estrutural: cada entrada carrega o NOME DE TIPO DO PLUGIN
// (@capgo/capacitor-health) que a leitura usaria, e o teste wearableTruth
// falha se qualquer pluginType daqui entrar em HEALTH_READ_TYPES sem sair
// desta lista. Promessa e leitura passam a ser conjuntos disjuntos por pin,
// não por disciplina.

// Deliberadamente NÃO tipado como HealthReadType: o invariante é justamente
// que pluginType NÃO pertença a HEALTH_READ_TYPES (permissionState.ts).
type FutureMetric = {
  /** Chave i18n do rótulo (existe nos 6 locales; o teste confere). */
  labelKey: string;
  /**
   * Nome do tipo no plugin de saúde (@capgo/capacitor-health), o MESMO
   * vocabulário de HEALTH_READ_TYPES. É a ponte que permite ao teste detectar
   * "prometido como futuro mas já lido" sem comparar strings de UI.
   */
  pluginType: string;
};

// HRV saiu (22/08): heartRateVariability está em HEALTH_READ_TYPES e a
// tendência dela renderiza nesta mesma tela de Insights.
export const SLEEP_FUTURE_METRICS: readonly FutureMetric[] = [
  { labelKey: "sleep.insights.spo2", pluginType: "oxygenSaturation" },
  { labelKey: "sleep.insights.respiratory", pluginType: "respiratoryRate" },
  { labelKey: "sleep.insights.temperature", pluginType: "bodyTemperature" },
] as const;
